

const TagsAnchorContainer = ({ legend, parts }) => {

  const scrollToSection = (ref, scrollAdjust) => {
    ref.current?.scrollIntoView();
    // Attendre un peu que le scroll initial se termine avant d'ajuster
    setTimeout(() => {
      const scrollPosittion = window.scrollY;
      window.scrollTo(0, scrollPosittion - scrollAdjust);
    }, 10);
  };

  return (
    <div className="tag-help-container">
      <p className="help-legend">{legend}</p>
      {parts.map((part, index) => {
        return (
          <p className="help-anchor-link" key={index} onClick={() => scrollToSection(part.ref, part.scrollAdjust)}>
            <img src="/images/tPNix101.svg" className="small-icon"/>
            {part.content}
          </p>
        )
      })}
    </div>
  )
}

export default TagsAnchorContainer